(function (scope) {
  'use strict';
  const ENDPOINT = 'https://portal.dotsontuning.com/api/analytics/storefront';
  const STORAGE = 'dotson_analytics_v1';
  const ATTRIBUTE = '__dotson_analytics_session';
  const SESSION_MS = 30 * 60 * 1000;
  const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
  const PRODUCTS = {'new15-21-wrx-e-tune-cobb':'6774651060247','22-wrx-e-tune-cobb':'6865499357207','14-18-forester-xt-e-tune':'7496462630935','22-wrx-ots-map':'6962971344919'};
  const SOURCES = {
    chatgpt:['ai','chatgpt'],chatgpt_com:['ai','chatgpt'],openai:['ai','chatgpt'],perplexity:['ai','perplexity'],claude:['ai','claude'],gemini:['ai','gemini'],copilot:['ai','copilot'],
    google:['search','google'],bing:['search','bing'],facebook:['social','facebook'],fb:['social','facebook'],instagram:['social','instagram'],ig:['social','instagram'],youtube:['social','youtube'],tiktok:['social','tiktok'],reddit:['social','reddit'],email:['email','email'],newsletter:['email','email'],partner:['partner','partner']
  };
  const REFERRERS = [['chatgpt.com','ai','chatgpt'],['chat.openai.com','ai','chatgpt'],['perplexity.ai','ai','perplexity'],['claude.ai','ai','claude'],['gemini.google.com','ai','gemini'],['copilot.microsoft.com','ai','copilot'],['google.com','search','google'],['bing.com','search','bing'],['facebook.com','social','facebook'],['instagram.com','social','instagram'],['youtube.com','social','youtube'],['youtu.be','social','youtube'],['tiktok.com','social','tiktok'],['reddit.com','social','reddit']];
  const EVENTS = new Set(['page_view','configuration_progress','cart_view','checkout_intent','lead_click']);
  const STAGES = new Set(['started','ready','blocked','cart_unconfirmed']);
  const REASONS = new Set(['required_fields','configuration_invalid','purchase_unavailable','cart_update']);
  function classify(env, marketing) {
    if (!marketing) return {source_category:'consent_withheld',source_name:'unknown'};
    try {
      const params = new URL(env.location.href).searchParams;
      const source = params.getAll('utm_source');
      const medium = params.getAll('utm_medium');
      if (medium.length === 1 && ['partner','affiliate'].includes(medium[0].toLowerCase())) return {source_category:'partner',source_name:'partner'};
      const known = source.length === 1 && SOURCES[source[0].toLowerCase()];
      if (known) return {source_category:known[0],source_name:known[1]};
      if (source.length || medium.length) return {source_category:'unknown',source_name:'unknown'};
      if (!env.document.referrer) return {source_category:'direct',source_name:'direct'};
      const host = new URL(env.document.referrer).hostname.toLowerCase();
      if (['www.dotsontuning.com','dotsontuning.com','portal.dotsontuning.com'].includes(host)) return {source_category:'direct',source_name:'direct'};
      const match = REFERRERS.find(([domain]) => host === domain || host.endsWith('.'+domain));
      return match ? {source_category:match[1],source_name:match[2]} : {source_category:'referral',source_name:'referral'};
    } catch (_) { return {source_category:'unknown',source_name:'unknown'}; }
  }
  function pageContext(env) {
    const path = env.location.pathname || new URL(env.location.href).pathname;
    if (/^\/(?:account|checkouts?|orders|apps)(?:\/|$)/i.test(path)) return null;
    const handle = path.match(/\/products\/([^/]+)\/?$/)?.[1];
    let page_type = 'content';
    if (path === '/') page_type = 'home';
    else if (handle) page_type = 'product';
    else if (/^\/collections(?:\/|$)/.test(path)) page_type = 'collection';
    else if (/^\/cart\/?$/.test(path)) page_type = 'cart';
    else if (/^\/pages\/(?:contact|contact-us)\/?$/.test(path)) page_type = 'contact';
    else if (/^\/pages\/(?:dyno-tuning|e-tuning|tuning-services)\/?$/.test(path)) page_type = 'service';
    const result = {page_type};
    if (PRODUCTS[handle]) result.product_id = PRODUCTS[handle];
    return result;
  }
  function install(env) {
    if (env.DotsonAnalytics) return env.DotsonAnalytics;
    const url = new URL(env.location.href);
    if (!['www.dotsontuning.com','dotsontuning.com'].includes(url.hostname) || env.Shopify?.theme?.role !== 'main' || env.Shopify?.designMode || url.searchParams.has('preview_theme_id') || url.searchParams.has('pb') || !pageContext(env)) return null;
    let session = null, linkedSession = '', pendingLink = null, cartPending = null, pageSession = '', consentWasAllowed = false;
    const sent = new Set();
    const now = () => Date.now();
    const privacy = () => env.Shopify?.customerPrivacy;
    const allowed = () => { try { return env.Shopify?.theme?.role === 'main' && !env.Shopify?.designMode && privacy()?.analyticsProcessingAllowed?.() === true; } catch (_) { return false; } };
    const marketing = () => { try { return privacy()?.marketingAllowed?.() === true; } catch (_) { return false; } };
    const uuid = () => { try { const id = env.crypto?.randomUUID?.(); return UUID.test(id || '') ? id : null; } catch (_) { return null; } };
    const removeStored = () => { try { env.sessionStorage.removeItem(STORAGE); } catch (_) {} };
    function readStored(includeExpired = false) {
      try {
        const value = JSON.parse(env.sessionStorage.getItem(STORAGE) || 'null');
        if (value && UUID.test(value.id) && Number.isFinite(value.last_seen) && value.last_seen <= now() && (includeExpired || now()-value.last_seen < SESSION_MS)) return value;
      } catch (_) {}
      return null;
    }
    function transmit(payload) {
      try {
        if (typeof env.fetch !== 'function') return false;
        env.fetch(ENDPOINT,{method:'POST',mode:'cors',credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',keepalive:true,headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify(payload)}).catch(()=>{});
        return true;
      } catch (_) { return false; }
    }
    function cartLink(id) {
      if (id && !allowed()) return;
      if (id && (linkedSession === id || pendingLink === id)) return;
      const route = new URL(env.Shopify?.routes?.root || '/',url.origin);
      if (route.origin !== url.origin) return;
      if (!route.pathname.endsWith('/')) route.pathname += '/';
      const body = JSON.stringify({attributes:{[ATTRIBUTE]:id}});
      pendingLink = id;
      const task = () => {
        if (id && (!allowed() || session?.id !== id)) return;
        return env.fetch(new URL('cart/update.js',route).href,{method:'POST',credentials:'same-origin',keepalive:true,headers:{'Content-Type':'application/json',Accept:'application/json'},body}).then(response => { if (response.ok) linkedSession = id; }).catch(()=>{});
      };
      cartPending = (cartPending || Promise.resolve()).then(task).catch(()=>{}).finally(()=>{ if (pendingLink === id) pendingLink = null; });
    }
    function revoke() {
      const old = session || readStored(true);
      session = null; consentWasAllowed = false; pageSession = ''; sent.clear(); removeStored();
      if (old?.id && UUID.test(old.id)) {
        const id = uuid();
        if (id) transmit({schema_version:1,event_id:id,session_id:old.id,event_name:'consent_revoked',event_time:new Date(now()).toISOString()});
        cartLink('');
      }
    }
    function activeSession() {
      if (!allowed()) { if (session || consentWasAllowed) revoke(); return null; }
      consentWasAllowed = true;
      const stored = session || readStored();
      const attributionAllowed = marketing();
      if (stored && stored.marketing === true && !attributionAllowed) { session = stored; revoke(); }
      if (!session) {
        if (stored && now()-stored.last_seen < SESSION_MS && stored.marketing === attributionAllowed) session = stored;
        else { const id = uuid(); if (!id) return null; session = {id,last_seen:now(),marketing:attributionAllowed,...classify(env,attributionAllowed)}; }
      }
      if (now()-session.last_seen >= SESSION_MS) { const id = uuid(); if (!id) return null; session = {id,last_seen:now(),marketing:attributionAllowed,...classify(env,attributionAllowed)}; }
      const category = session.source_category, source = session.source_name;
      if (!['direct','ai','social','search','partner','email','referral','unknown','consent_withheld'].includes(category) || !['direct','chatgpt','perplexity','claude','gemini','copilot','google','bing','facebook','instagram','youtube','tiktok','reddit','email','partner','referral','other','unknown'].includes(source)) Object.assign(session,classify(env,attributionAllowed));
      session.last_seen = now();
      try { env.sessionStorage.setItem(STORAGE,JSON.stringify(session)); } catch (_) {}
      cartLink(session.id);
      return session;
    }
    function track(name, fields = {}) {
      try {
        if (!EVENTS.has(name)) return false;
        const context = pageContext(env), current = activeSession();
        if (!context || !current || !allowed()) return false;
        const payload = {schema_version:1,event_id:uuid(),session_id:current.id,event_name:name,event_time:new Date(now()).toISOString(),...context,source_category:current.source_category,source_name:current.source_name,device_category:env.innerWidth > 0 ? env.innerWidth < 768 ? 'mobile' : env.innerWidth < 1024 ? 'tablet' : 'desktop' : 'unknown'};
        if (!payload.event_id) return false;
        if (name === 'configuration_progress') {
          const needsReason = ['blocked','cart_unconfirmed'].includes(fields.configuration_stage);
          if (!Object.values(PRODUCTS).includes(String(fields.product_id)) || !['etune','ots'].includes(fields.configuration_type) || !STAGES.has(fields.configuration_stage) || (needsReason ? !REASONS.has(fields.block_reason) : !!fields.block_reason)) return false;
          Object.assign(payload,{product_id:String(fields.product_id),configuration_type:fields.configuration_type,configuration_stage:fields.configuration_stage});
          if (fields.block_reason) payload.block_reason = fields.block_reason;
        }
        const key = current.id+':'+name+':'+(payload.product_id || '')+':'+(payload.configuration_stage || '')+':'+(payload.block_reason || '');
        if (sent.has(key)) return false;
        if (!transmit(payload)) return false;
        sent.add(key); return true;
      } catch (_) { return false; }
    }
    function activate() {
      try {
        if (!allowed()) { revoke(); return; }
        const current = activeSession();
        if (!current || current.id === pageSession) return;
        pageSession = current.id;
        track('page_view');
        if (pageContext(env)?.page_type === 'cart') track('cart_view');
      } catch (_) {}
    }
    env.document.addEventListener('visitorConsentCollected',activate);
    env.document.addEventListener('click',event => {
      if (!event.isTrusted) return;
      try {
        const target = event.target?.closest?.('a,button,input');
        if (!target) return;
        if (target.matches?.('[name="checkout"]') || target.closest?.('.shopify-payment-button')) { track('checkout_intent'); return; }
        const href = target.getAttribute?.('href');
        if (!href) return;
        const link = new URL(href,url.origin);
        if (link.origin === url.origin && /^\/checkout\/?$/.test(link.pathname)) track('checkout_intent');
        else if (link.protocol === 'tel:' || link.protocol === 'mailto:' || (link.origin === url.origin && /^\/pages\/(?:contact|contact-us)\/?$/.test(link.pathname)) || (link.hostname === 'portal.dotsontuning.com' && /^\/(?:inquiry|inquiries|contact)(?:\/|$)/.test(link.pathname))) track('lead_click');
      } catch (_) {}
    },true);
    env.document.addEventListener('submit',event => { if (event.isTrusted && event.submitter?.name === 'checkout') track('checkout_intent'); },true);
    const api = {track,sessionKey:()=>activeSession()?.id || null};
    env.DotsonAnalytics = api;
    if (privacy()) activate();
    else { try { env.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.2'}],error=>{ if (!error) activate(); }); } catch (_) {} }
    return api;
  }
  if (typeof module === 'object' && module.exports) module.exports = {install,classify,pageContext};
  else { try { install(scope); } catch (_) {} }
})(typeof window === 'undefined' ? {} : window);
